import React, { PureComponent } from 'react';

import { COLORS } from '../constants';

import ColorBlock from './color-block';

const selectableColors = Object.keys(COLORS).filter(color => COLORS[color].selectable);

export default class ColorSelector extends PureComponent { 
    state = {
        selected: this.props.selected
    }

    handleClick = (color, secondaryColor) => {
        this.setState({
            selected: color
        });

        this.props.onChange?.(color, secondaryColor);
    }

    render() {
        return (
            <div className={'color-selector' + (this.props.compact ? ' compact' : '')}>
                {
                    this.props.label ? (
                        <div className="field-label no-gutter dark">{this.props.label}</div>
                    ) : null
                }

                <div className="options">
                    {
                        this.props.withTransparent ? (
                            <ColorBlock
                                key="transparent"
                                color="transparent"
                                selected={!this.state.selected || this.state.selected === 'transparent'}
                                onClick={this.handleClick}
                            />
                        ) : null
                    }
                    {
                        selectableColors.map(color => <ColorBlock
                            key={color}
                            color={color}
                            selected={color === this.state.selected}
                            onClick={this.handleClick}
                        />)
                    }
                </div>
            </div>
        )
    }
}
